import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import Api from '../../Utils/api';
import _ from 'lodash';
import Utils from "../../Utils/Utility";
import CONFIG_HELPER from './../../../ConfigHelper';
import Actions from "../../actions";
import MainStore from '../stores/main-store';
import Counter from '../generic/counter';
import AddOptions from './add-options';
import AddItem from "./add-item";


// itemOptionCategories
export default class AddModifier extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            optionCategoryName:"",
            optionRequired:false,
            optionMinChoose:0,
            optionMaxChoose:0,
            isOptionQtyAllowed:0,
            itemOptions: [],
            errors: {},
            itemOptionData:{},
            selectedModifierRow:"",
            duplicateModifier:false
        }

        this._bind(
            'addItemOptionsAction',
            'onMinSelectionChanged',
            'onMaxSelectionChanged',
            'addModifierSubmit',
            'loadModifier'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        // when load the main class get all the data and reload
        this.loadModifier();
    }


    componentWillMount() {

        this.setState({
            itemOptionData: this.props.itemOptionData,
            selectedModifierRow: this.props.selectedModifierRow,
            duplicateModifier: this.props.duplicateModifier
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null) {
            this.setState({
                    itemOptionData: nextProps.itemOptionData,
                    selectedModifierRow: nextProps.selectedModifierRow,
                    duplicateModifier: nextProps.duplicateModifier
                },
                () => {
                    this.loadModifier();
                });
        }
    }

    loadModifier(){

       let itemOptionData = this.state.itemOptionData;
       let duplicateModifier = this.state.duplicateModifier;
        let selectedModifierRow = this.state.selectedModifierRow;

       if (itemOptionData && !Utils.isEmptyObj(itemOptionData)){

           let categoryName = itemOptionData.category;

           if (duplicateModifier){
               categoryName = itemOptionData.category+" COPY";

           }

           this.setState({
               "optionCategoryName": categoryName,
               "optionRequired": itemOptionData.required,
               "optionMinChoose": itemOptionData.minChoose,
               "optionMaxChoose": itemOptionData.maxChoose,
               "isOptionQtyAllowed": itemOptionData.allowOptionQty,
               "itemOptions": itemOptionData.options,
           });
       }

    }

    onMinSelectionChanged(minChoose) {
       // let optionMinChoose = this.state.optionMinChoose;
       let optionMaxChoose = this.state.optionMaxChoose;

       // let newMinChoose = optionMinChoose + 1;

       if (minChoose > optionMaxChoose){
           // error
           let errors = {};
           errors["optionMinChoose"] = "Minimum value can't exceed maximum value.";
           this.setState({errors: errors});
       }
       else{
           this.setState({ optionMinChoose : minChoose }, ()=>{
               this.setRequiredOptionalLabel();
           });
       }

    }

    onMaxSelectionChanged(maxChoose) {
        let optionMinChoose = this.state.optionMinChoose;
        let optionMaxChoose = this.state.optionMaxChoose;

      if(maxChoose < optionMinChoose){
          // error
          let errors = {};
          errors["optionMaxChoose"] = "Maximum value can't be less than minimum value.";
          this.setState({errors: errors});

      }
      else{

          this.setState({ optionMaxChoose : maxChoose }, ()=>{
              this.setRequiredOptionalLabel();
          });
      }

    }

    setRequiredOptionalLabel(){
        let optionMinChoose = this.state.optionMinChoose;

        if (optionMinChoose == 0){
        // set optional

            this.setState({ optionRequired : false });

        }
        else {
      // set required

            this.setState({ optionRequired : true });
        }

    }

    handleValidation(){
        let optionCategoryName = this.state.optionCategoryName;
        let errors = {};
        let formIsValid = true;
       let itemOptions = this.state.itemOptions;

        //Name
        if(optionCategoryName == "" || optionCategoryName == undefined){
            formIsValid = false;
            errors["optionCategoryName"] = "Cannot be empty";
        }

        if (itemOptions.length == 0){
            formIsValid = false;
            errors["errors"] = "Please add Options/Add-ons.";
        }

        this.setState({errors: errors});
        return formIsValid;
    }

    addModifierSubmit(){

        let self = this;
        if(this.handleValidation()){


           var optionCategory = this.props.itemOptionData;

            if (optionCategory && !Utils.isEmptyObj(optionCategory)) {
                optionCategory.category = this.state.optionCategoryName;
                optionCategory.required = this.state.optionRequired;
                optionCategory.minChoose = this.state.optionMinChoose;
                optionCategory.maxChoose = this.state.optionMaxChoose;
                optionCategory.allowOptionQty = this.state.isOptionQtyAllowed == 1 ? true : false;
                optionCategory.options = this.updateItemOptionsArrayValue(this.state.itemOptions);
                self.props.callBackAddModifiers(optionCategory, this.state.selectedModifierRow);
            }
            else {

                let paramsObject = {
                    "category": this.state.optionCategoryName,
                    "required": this.state.optionRequired,
                    "minChoose": this.state.optionMinChoose,
                    "maxChoose": this.state.optionMaxChoose,
                    "allowOptionQty": this.state.isOptionQtyAllowed == 1 ? true : false,
                    "options": this.updateItemOptionsArrayValue(this.state.itemOptions)
                };

                self.props.callBackAddModifiers(paramsObject, this.state.selectedModifierRow);
            }
        }
    }

    updateItemOptionsArrayValue(itemOptionsArray){

        itemOptionsArray.forEach(function (obj){

            let optionName = Object.keys(obj)[0];
            let nestedJson = obj[optionName];

            if (typeof nestedJson.price === 'string') {
                nestedJson['price'] = Number(nestedJson.price);
            }
        })
        return itemOptionsArray;

    }

    handleChange(field, e){

        if (field == "optionCategoryName"){
            let nameValue = e.target.value;
            this.setState({
                optionCategoryName: nameValue
            });
        }

        if (field == "isOptionQtyAllowed"){
            let qtyValue = e.target.value;

            this.setState({
                isOptionQtyAllowed: qtyValue
            });
        }
    }

    addItemOptionsAction(itemOptionsArray){

        let self = this;
        self.setState({
            itemOptions : itemOptionsArray
        });
    }


    render() {

        return (
            <div className="order-pg">
                {/*{!this.state.isLoaded ? <Spinner/> : null}*/}

                <div className="border-class marginTop">
                    <h3 id="translations" className="page-header">Add Modifier</h3>
                    {
                        this.state.errors["errors"] ? (
                            <div className="alert alert-danger text-center" role="alert">
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                    }

                    <div>
                        <div className="form-group">
                            <label htmlFor="labelName">Name</label>
                            <input type="text" className="form-control" id="optionCategoryName" ref="optionCategoryName"
                                   aria-describedby="optionCategoryName" placeholder="Enter name"
                                   onChange={this.handleChange.bind(this, "optionCategoryName")}
                                   value={this.state.optionCategoryName}/>
                            <span style={{color: "red"}}
                                  className="form-text">{this.state.errors["optionCategoryName"]}
                            </span>
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1">Selection Rule {
                                this.state.optionRequired ? "(Required)" : "(Optional)"

                            }</label>
                            <div>
                                <div className="row form-group">
                                    <div className="col-xs-2 counter-label">
                                        Minimum Selection :
                                    </div>
                                    <div className="col-xs-3">
                                        <Counter
                                            name="optionMinChoose"
                                            min="0"
                                            max={this.state.optionMaxChoose}
                                            currentValue={this.state.optionMinChoose}
                                            callbackParent={this.onMinSelectionChanged}
                                        />
                                    </div>
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["optionMinChoose"]}</span>
                                </div>
                                <div className="row form-group">
                                    <div className="col-xs-2 counter-label">
                                        Maximum Selection :
                                    </div>
                                    <div className="col-xs-3">
                                        <Counter
                                            name="optionMaxChoose"
                                            min={this.state.optionMinChoose}
                                            max="1000"
                                            currentValue={this.state.optionMaxChoose}
                                            callbackParent={this.onMaxSelectionChanged}
                                        />
                                    </div>
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["optionMaxChoose"]}</span>
                                </div>

                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1">Show Option Qty Selector</label>
                            <div onChange={this.handleChange.bind(this, "isOptionQtyAllowed")}>
                                <label className="radio-inline">
                                    <input type="radio" name="isOptionQtyAllowed"
                                           value="0" checked={this.state.isOptionQtyAllowed == false} /> Disable
                                </label>
                                <label className="radio-inline">
                                    <input type="radio" name="isOptionQtyAllowed"
                                           value="1" checked={this.state.isOptionQtyAllowed == true} /> Enable
                                </label>
                            </div>
                            <span style={{color: "red"}} className="form-text">{this.state.errors["isOptionQtyAllowed"]}</span>
                        </div>

                        <div className="form-group">
                            <div className="col-lg-12">
                                <h4 id="translations" className="page-header">OPTIONS/ADD-ONS</h4>
                            </div>
                            <div className="col-md-12">

                                <AddOptions
                                    callBackAddOptions={this.addItemOptionsAction}
                                    itemOptions={this.state.itemOptions}
                                />

                            </div>
                        </div>

                        <div className="form-group">
                            <button type="submit" className="btn btn-export" onClick={this.addModifierSubmit}>Save</button>
                            <button type="submit" className="btn btn-default back-button" onClick={this.props.callBackParent} >Back</button>
                        </div>
                    </div>
                </div>


            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/online-menu/add-modifier.js